const REPLACEMENT = '_';
const FORWARD_SLASH = '/';
const SPACE = ' ';

export const articleNumberUrlEncoding = (articleNumber: string): string => {
  const articleNumberWithEncodedSpaces = articleNumber.replace(SPACE, REPLACEMENT);

  return articleNumberWithEncodedSpaces.replace(FORWARD_SLASH, REPLACEMENT);
};
